import {
  Phone, Video, Users, Mail, MessageCircle, Linkedin, Presentation,
  FileText, FileClock, Handshake, MapPin, Cpu, DollarSign, FileCheck,
  MessagesSquare, Bell, ClipboardList, Circle,
} from "lucide-react";

export const ACTIVITY_TYPES = [
  { value: "phone_call",            label: "Phone Call",           icon: Phone },
  { value: "video_call",            label: "Video Call",           icon: Video },
  { value: "meeting",               label: "Meeting",              icon: Users },
  { value: "email",                 label: "Email",                icon: Mail },
  { value: "whatsapp",              label: "WhatsApp",             icon: MessageCircle },
  { value: "linkedin",              label: "LinkedIn",             icon: Linkedin },
  { value: "demo",                  label: "Demo",                 icon: Presentation },
  { value: "proposal_sent",         label: "Proposal Sent",        icon: FileText },
  { value: "proposal_followup",     label: "Proposal Follow-up",   icon: FileClock },
  { value: "negotiation",           label: "Negotiation",          icon: Handshake },
  { value: "site_visit",            label: "Site Visit",           icon: MapPin },
  { value: "technical_discussion",  label: "Technical Discussion", icon: Cpu },
  { value: "pricing_discussion",    label: "Pricing Discussion",   icon: DollarSign },
  { value: "contract_review",       label: "Contract Review",      icon: FileCheck },
  { value: "internal_discussion",   label: "Internal Discussion",  icon: MessagesSquare },
  { value: "reminder",              label: "Reminder",             icon: Bell },
  { value: "task",                  label: "Task",                 icon: ClipboardList },
  { value: "other",                 label: "Other",                icon: Circle },
];

export const ACTIVITY_MAP = Object.fromEntries(ACTIVITY_TYPES.map((t) => [t.value, t]));

export function isOverdue(activity) {
  if (!activity?.scheduled_date || activity.status !== "planned") return false;
  return new Date(activity.scheduled_date) < new Date();
}

export function displayStatus(activity) {
  if (activity.status === "planned" && isOverdue(activity)) return "overdue";
  return activity.status;
}

export const STATUS_STYLE = {
  planned:   "bg-primary/10 text-primary",
  completed: "bg-emerald-600/10 text-emerald-700",
  cancelled: "bg-secondary text-muted-foreground",
  overdue:   "bg-destructive/10 text-destructive",
};

export function dayLabel(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const now = new Date();
  const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diff = Math.round((day - today) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === -1) return "Yesterday";
  if (diff < 0) return `${Math.abs(diff)}d ago`;
  if (diff < 7) return `In ${diff}d`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function fmtDateTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}
